module.exports = __webpack_public_path__ + "static/img/app2.cd57b69.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/app2.png
// module id = hezs
// module chunks = 1